import React from 'react';
import '../styles/hero.css';

const BULLETS = [
  'NEA-approved real-time noise monitoring provider',
  'End-to-end geotechnical & vibration instrumentation',
  'Cloud-connected IoT sensors with live dashboards',
  '500+ vibration monitoring units and 50+ noise monitoring systems deployed across Singapore and Malaysia',
];

const Hero: React.FC = () => {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="cv-hero">
      {/* Bottom fade into page bg */}
      <div className="cv-hero__fade" />

      <div className="cv-hero__inner">
        {/* LEFT: Text */}
        <div className="cv-hero__text">
          <p className="cv-hero__eyebrow">Singapore's Infrastructure Monitoring Specialist</p>

          <h1 className="cv-hero__title">
            Noise, Vibration &amp; Geotechnical Monitoring<br />
            <span className="cv-hero__accent">for Critical Infrastructure</span>
          </h1>

          <p className="cv-hero__company-name">CoreVision Pte Ltd</p>

          <p className="cv-hero__subtitle">
            CoreVision provides noise monitoring, vibration monitoring, and geotechnical monitoring
            services in Singapore — from sensor installation to real-time cloud dashboards and
            regulatory reporting.
          </p>

          <ul className="cv-hero__bullets">
            {BULLETS.map((b) => (
              <li key={b}>
                <span className="cv-hero__bullet-dot" />
                {b}
              </li>
            ))}
          </ul>

          <div className="cv-hero__actions">
            <button className="cv-btn cv-btn--primary" onClick={() => scrollTo('#contact')}>
              Request a Consultation
            </button>
            <button className="cv-btn cv-btn--outline" onClick={() => scrollTo('#services')}>
              Our Services
            </button>
          </div>
        </div>

        {/* RIGHT: Image */}
        <div className="cv-hero__image-wrap">
          <img
            src="/images/real-time-monitoring.jpg"
            alt="MRT tunnel vibration and geotechnical monitoring Singapore"
            className="cv-hero__image"
          />
          <div className="cv-hero__image-badge">
            <span className="cv-hero__badge-value">24 / 7</span>
            <span className="cv-hero__badge-label">Live Monitoring</span>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="cv-hero__stats-bar">
        <div className="cv-container cv-hero__stats-inner">
          {[
            { value: 'EXPERIENCE', label: '20+ Years Combined Engineering Experience' },
            { value: 'APPROVAL', label: 'NEA Approved Real-Time Noise Monitoring Provider' },
            { value: 'MONITORING', label: 'Cloud-Connected Monitoring with Timely Alerts' },
            { value: 'SUPPORT', label: 'Practical Deployment, Reporting, and Ongoing Support' },
          ].map((s, i, arr) => (
            <React.Fragment key={s.label}>
              <div className="cv-hero__stat">
                <span className="cv-hero__stat-value">{s.value}</span>
                <span className="cv-hero__stat-label">{s.label}</span>
              </div>
              {i < arr.length - 1 && <div className="cv-hero__stat-sep" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
